import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddGlaTranslatorsDialogComponent } from './add-gla-translators-dialog.component';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../../app/app-material/app-material.module';
@NgModule({
  declarations: [AddGlaTranslatorsDialogComponent],
  imports: [AppMaterialModule, CommonModule, FormsModule],
  entryComponents: [AddGlaTranslatorsDialogComponent]
})
export class AddGlaTranslatorsDialogModule {}
